import React, { useState, useEffect } from 'react'
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'
import { getUser } from '../../../../services/oneUser'
import CookieManager from '../../../lib/CookiesManager'

interface UserServicesEstablishmentFormProps {
  formData: { title: string; description: string }
  handleFieldChange: (field: string, value: any) => void
}

const UserServicesEstablishmentForm: React.FC<
  UserServicesEstablishmentFormProps
> = ({}) => {
  const { t } = useTranslation()
  const myProfile = localStorage.getItem('myProfile')

  const getLocalStorageData = () => {
    const data = localStorage.getItem('myEstablishment')
    return data ? JSON.parse(data) : {}
  }

  const [status, setStatus] = useState<string[]>(() => {
    const localStorageData = getLocalStorageData()
    return localStorageData.status || []
  })

  useEffect(() => {
    const fetchUserEmail = async () => {
      const userId = CookieManager.getUserId()
      const token = CookieManager.getToken()

      if (userId && token) {
        try {
          const userData = await getUser(userId, token)
          const userEmail = userData.user.email

          const myEstablishment = JSON.parse(
            localStorage.getItem('myEstablishment') || '{}',
          )
          myEstablishment.email = userEmail
          myEstablishment.practices = myEstablishment.practices || []
          localStorage.setItem(
            'myEstablishment',
            JSON.stringify(myEstablishment),
          )
        } catch (error) {
          Sentry.captureException(error, {
            extra: {
              action: 'fetchUserEmail',
              userId,
              timestamp: new Date().toISOString(),
            },
            tags: {
              type: 'api_error',
              method: 'fetchUserEmail',
            },
          })
        }
      }
    }

    fetchUserEmail()
  }, [])

  useEffect(() => {
    const userId = CookieManager.getUserId()
    const localStorageData = getLocalStorageData()

    if (userId) {
      localStorageData.userId = userId
    }

    if (!localStorageData.location) {
      localStorageData.location = []
    }

    if (!localStorageData.practices) {
      localStorageData.practices = []
    }

    localStorage.setItem('myEstablishment', JSON.stringify(localStorageData))
  }, [])

  useEffect(() => {
    const localStorageData = getLocalStorageData()
    localStorageData.status = status
    localStorage.setItem('myEstablishment', JSON.stringify(localStorageData))
  }, [status])

  const handleSelectionChange = (option: string) => {
    setStatus(prevStatus =>
      prevStatus.includes(option)
        ? prevStatus.filter(item => item !== option)
        : [...prevStatus, option],
    )
  }

  const options = [
    { id: 'maison privee', description: t('create-ad.brothel') },
    { id: 'bars et clubs prive', description: t('create-ad.private-club') },
    { id: 'salons de massage', description: t('create-ad.massage-parlor') },
    { id: 'hotels coquins', description: t('create-ad.naughty-hotel') },
    { id: 'saunas prives', description: t('create-ad.spa-and-wellness') },
    { id: 'clubs echangistes', description: t('create-ad.swinger-club') },
  ]

  return (
    <>
      <div className='flex gap-4 justify-between uppercase text-center font-bold'></div>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3 lg:gap-4'>
        {options.map(option => (
          <div
            key={option.id}
            className={`p-2 sm:p-3 lg:p-4 cursor-pointer text-center rounded-lg text-anthracite ${
              status.includes(option.id)
                ? 'bg-redpink text-white'
                : 'bg-grisclair'
            }`}
            onClick={() => handleSelectionChange(option.id)}
          >
            <div className='flex items-center justify-center bg-anthracite p-2 sm:p-3 uppercase rounded-md'>
              {status.includes(option.id) ? (
                <MdCheckBox className='mr-2 sm:mr-3 text-lg sm:text-xl' />
              ) : (
                <MdCheckBoxOutlineBlank className='mr-2 sm:mr-3 text-lg sm:text-xl text-white' />
              )}
              <div>
                <div className='block text-white text-sm sm:text-base'>
                  {t(`create-ad.${option.id}`)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default UserServicesEstablishmentForm
